import { useEffect } from "react";

const options = {
	rootMargin: "0px",
	threshold: 0,
};

const createIntersectionListenerToItems = ({ items, onItemIntersection }) => {
	const elementToPageIndexMap = new Map();

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}

			const pageIndex = elementToPageIndexMap.get(entry.target);

			if (!onItemIntersection) {
				return;
			}

			onItemIntersection({
				pageIndex,
			});
		});
	}, options);

	Object.entries(items).forEach(([pageIndex, element]) => {
		const pageIndexNum = parseInt(pageIndex);

		if (isNaN(pageIndexNum)) {
			console.error(
				`[INTERACTIVE PRODUCTS] Page index \`${pageIndex}\` on productsByPages obj is not a number.`
			);
			return;
		}

		elementToPageIndexMap.set(element, pageIndexNum);

		// Tohle se normálně nestane, jenom kdyby přišlo více
		// produktů, než je elementů na stránce.
		if (element === undefined) {
			console.warn(
				"[INTERACTIVE-PRODUCTS] Element is undefined",
				pageIndex,
				element
			);
			return;
		}

		observer.observe(element);
	});

	return { observer };
};

export const useAddLazyLoadingIntersectionObserver = ({
	enableLazyLoading = false,
	containers,
	onItemIntersection,
}) => {
	useEffect(() => {
		if (!enableLazyLoading) {
			return;
		}

		const { observer } = createIntersectionListenerToItems({
			items: containers,
			onItemIntersection,
		});

		return () => {
			observer.disconnect();
		};
	}, [enableLazyLoading, containers, onItemIntersection]);
};
